<template>
  <div class="row justify-content-center">
    <!--Esta es la página de Remates. Posee dos componentes que corresponden a las dos pestañas de la página: Próximos Remates y Resultados-->
    <div class="col-md-12 px-0 px-xl-4">
      <div class="tab-content my-4 my-lg-5" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-remates" role="tabpanel" aria-labelledby="nav-remates-tab">
          <remates-proximos :remates="remates" :consignatarios="consignatarios" :ubicaciones="ubicaciones" :especies="especies"
            :destinos="destinos" :razas="razas" :cabanas="cabanas" :tipos="tipos" :modalidades="modalidades"
            :publicidad="publicidad" :banner="banner" :bannerasideright="bannerasideright"
            :bannerpaginacion="bannerpaginacion"  @sendData="handleOffsetValue">
          </remates-proximos>
        </div>
        <div class="tab-pane fade" id="nav-resultados" role="tabpanel" aria-labelledby="nav-resultados-tab">
          <remates-resultados :remates="resultados" :consignatarios="consignatarios" :ubicaciones="ubicaciones"
            :especies="especies" :destinos="destinos" :razas="razas" :cabanas="cabanas" :tipos="tipos"
            :modalidades="modalidades" :publicidad="publicidad" :banner="banner"
            :bannerasideright="bannerasideright" :bannerpaginacion="bannerpaginacion" :receivedOffsetValue="offsetValue">
          </remates-resultados>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: [
    'remates',
    'resultados',
    'consignatarios',
    'ubicaciones',
    'especies',
    'destinos',
    'razas',
    'cabanas',
    'tipos',
    "modalidades",
    "publicidad",
    "banner",
    "bannerasideright",
    "bannerpaginacion",
  ],
  data() {
    return {
      offsetValue: null
    }
  },
  methods: {
    handleOffsetValue(val) {
      this.offsetValue = val;
    }
  }
}
</script>